<template>
  <v-toolbar height="56" dark class="primary">
    <v-btn :icon="true" dark @click.native="back()">
      <v-icon>arrow_back</v-icon>
    </v-btn>
    <v-toolbar-title>
      <router-link :to="{ name: 'ApplicationSelector' }" tag="span" id="title">
        {{ brand.title }}
      </router-link>
    </v-toolbar-title>
    <v-spacer />
    <locale-switcher button-class="white--text" />
    <v-menu
      v-if="navLinks.length > 0"
      bottom
      left
      origin="top right"
      transition="v-scale-transition"
    >
      <template v-slot:activator="{ on }">
        <v-btn icon="icon" v-on="on" class="white--text">
          <v-icon>more_vert</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="link in navLinks"
          :key="link.key"
          :to="link.to || undefined"
          @click="link.onClick ? link.onClick() : undefined"
        >
          <v-list-item-title>
            {{ link.label }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-toolbar>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import config from '@/config';
import axios from 'axios';
import LocaleSwitcher from '@/components/shared/LocaleSwitcher';

export default {
  name: 'navbar',
  components: {
    LocaleSwitcher,
  },
  data() {
    return {
      routes: [
        'GroupList',
        'UserList',
        'TerminalList',
        'ApplicationList',
        'BrandEditor',
        'MyUserEditor',
        'LoadTest',
      ],
    };
  },
  computed: {
    ...mapGetters(['brand', 'user', 'isUserAdmin']),
    canGoBack() {
      return window.history.length > 1;
    },
    navLinks() {
      const routeExists = (route) => route.matched.length;

      const routes = this.routes.map(this.getRoute).filter(routeExists);

      return [
        ...routes.map((route) => ({
          key: route.name,
          // fall back to the route name if no label key is set
          label: route.meta.labelKey ? this.$t(route.meta.labelKey) : route.name,
          to: route,
          hidden: this.isAdminRoute(route) && !this.isUserAdmin,
        })),
        {
          key: 'resetSystem',
          label: this.$t('nav.resetSystem'),
          onClick: this.resetSystem,
          hidden: !this.isUserAdmin,
        },
        {
          key: 'logOut',
          label: this.$t('nav.logOut'),
          onClick: this.logOut,
          // OpenAM Bug. See https://bugster.forgerock.org/jira/browse/OPENAM-15531
          hidden: config.features.agcoCustomerPortalAuth || config.features.agcoDealerPortalAuth,
        },
      ].filter((link) => !link.hidden);
    },
  },
  methods: {
    ...mapActions(['logOut']),
    getRoute(name) {
      // route.path is immutable, so you can't router-link using an object that includes path
      const { path, ...route } = this.$router.resolve({ name }).route;
      return route;
    },
    async resetSystem() {
      try {
        await axios.delete('instances/');
        this.$router.push({ name: 'ApplicationSelector' });
      } catch (error) {
        this.logError(error);
      }
    },
    isAdminRoute(route) {
      return route.matched.some((match) => match.parent && match.parent.name === 'AdminWrapper');
    },
    back() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
#title {
  cursor: pointer;
}
</style>
